import React from 'react'

export default (value) => {
    return (
        <div className="inset" style={{ height: value, width: '100%', display: 'table'}}></div>
    )
}